<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0 mb-20">
      <div class="flex">
        <div class="w-1/3 space-y-4">
          <div class="flex justify-start space-x-1">
            <button class="btn_blue" @click="onSave">Spara</button>
            <createapiscopedlg />
            <button class="btn_default" @click="onRemove">Radera</button>
          </div>
          <select class="w-full form-select" v-model="selectedScope">
            <option v-for="s in current.scopes" :key="s.id" :value="s">
              {{s.name}}
            </option>
          </select>
          <div class="mt-5 space-y-4">
            <div>
              <span class="form-label">Visningsnamn</span>
              <input v-model="selectedScope.displayName" type="text" class="w-full mt-1 form-input" />
            </div>

            <div>
              <span class="form-label">Beskrivning</span>
              <textarea rows="4" v-model="selectedScope.description" type="text" class="w-full mt-1 form-input" />
              </div>

            <label class="inline-flex items-center mt-5">
                <input type="checkbox" class="form-checkbox" v-model="selectedScope.showInDiscoveryDocument" />
                <span class="form-label ml-2">Visa i Discovery Dokumentet?</span>
            </label>
          </div>
        </div>
      </div>
    </div>
     <DialogBase />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateApiScopeDlg from "./CreateApiScopeDlg";
import DialogBase from "@/components/dialogs/DialogBase.vue";
import { destroyDialog } from "@/components/dialogs/dialogs";

export default {
  name: "apiscopes",
  components: { createapiscopedlg: CreateApiScopeDlg, DialogBase },

  data() {
    return {
      selectedScope: {}
    };
  },

  computed: {
    ...mapGetters("apiresourcesStore", ["current"])
  },

  methods: {
    ...mapActions("apiresourcesStore", ["saveScope", "removeScope"]),

    onSave() {
      this.saveScope(this.selectedScope);
    },
    onRemove() {
      const callback = async () => {
        try {
          await this.removeScope(this.selectedScope);
        } finally {
          this.$modal.hide("dialog-base");
        }
      };
      destroyDialog(
        this,
        callback,
        "Api Scope " + this.selectedScope.displayName
      );
    }
  },

  mounted() {
    this.selectedScope = this.current.scopes[0];
  }
};
</script>
